export default __webpack_public_path__ + "static/media/checkShield.39c85a22.svg";